export const get = async (teamId) => {
    const response = await fetch(`metricType`);
    return await response.json();
};

export default
{
    get
}